import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { PlusPencilFeatherIcon } from "../../icons";
import { GenerateBookAIModal } from "../Modals/GenerateBookAIModal";

export const GenerateBookAIButton: FC = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onClick = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => onClick()}
        className="bg-sand-500 hover:bg-sand-800 inline-flex items-center gap-x-1 sm:gap-x-2 rounded px-2 sm:px-3.5 py-1.5 sm:py-2.5 text-xs sm:text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sand-600"
      >
        <PlusPencilFeatherIcon className="w-4 h-4 sm:w-5 sm:h-5" />
        <span className="inline">{t("generateBookAI.title")}</span>
      </button>
      <GenerateBookAIModal open={isModalOpen} setOpen={setIsModalOpen} />
    </>
  );
};
